var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltersS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3766 10.9743C5.19998 10.9743 5.05192 10.9146 4.93244 10.7951C4.81295 10.6756 4.75321 10.5276 4.75321 10.3509V6.61056L1.13751 1.99743C0.981665 1.78963 0.958287 1.57145 1.06738 1.34287C1.17648 1.11429 1.36609 1 1.63623 1H10.3638C10.6339 1 10.8235 1.11429 10.9326 1.34287C11.0417 1.57145 11.0183 1.78963 10.8625 1.99743L7.24679 6.61056V10.3509C7.24679 10.5276 7.18705 10.6756 7.06756 10.7951C6.94808 10.9146 6.80002 10.9743 6.6234 10.9743H5.3766ZM6 6.17418L9.08581 2.24679H2.91419L6 6.17418Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersS);
export default __webpack_public_path__ + "static/media/filters-s.13f5aaeed6d22e4ad976eb7ab554d402.svg";
export { ForwardRef as ReactComponent };